import { render, staticRenderFns } from "./ForgotPasswd.vue?vue&type=template&id=75231295&"
import script from "./ForgotPasswd.vue?vue&type=script&lang=js&"
export * from "./ForgotPasswd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports